import { ActivityChemicalsDTO } from '@behavior/activity/dto/ActivityChemicalsDTO';
import { ActivityDTO } from '@behavior/activity/dto/ActivityDTO';
import { useState } from 'react';
import { ActivityState } from './types/ActivityStates';
import { ContactDTO } from '@behavior/inventories/dto/ContactDTO';
import { LocationDTO } from '@behavior/inventories/dto/LocationDTO';

export const useActivityState = () => {
  const [activity, setActivity] = useState<ActivityDTO>();
  const [title, setTitle] = useState('');
  const [text, setText] = useState('');
  const [selectedContacts, setSelectedContacts] = useState<ContactDTO[]>([]);
  const [department, setDepartment] = useState('');
  const [selectedLocations, setSelectedLocations] = useState<LocationDTO[]>([]);
  const [outOfBuilding, setOutOfBuilding] = useState(false);
  const [chemicalProductsList, setChemicalProductsList] = useState<ActivityChemicalsDTO[]>([]);
  const [chemicalProductIdList, setChemicalProductIdList] = useState<number[]>([]);
  const [chemicalCards, setChemicalCards] = useState<number[]>([]);
  const [count, setCount] = useState(0);
  const addChemicalCard = () => {
    setCount(count + 1);
    setChemicalCards([...chemicalCards, count]);
  };

  return {
    activity,
    setActivity,
    title,
    setTitle,
    text,
    setText,
    selectedContacts,
    setSelectedContacts,
    department,
    setDepartment,
    selectedLocations,
    setSelectedLocations,
    outOfBuilding,
    setOutOfBuilding,
    chemicalProductsList,
    setChemicalProductsList,
    chemicalProductIdList,
    setChemicalProductIdList,
    chemicalCards,
    setChemicalCards,
    count,
    setCount,
    addChemicalCard,
  } as ActivityState;
};
